// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2aJYf","head":"ProcedureTableInfo_head__2oLYp"};